<div class="group-repeater-container">

  <table class="content-table">

    <thead>
      <tr class="sem-group-repeater-table-header">
        @for (headerText of headerTitles; track headerText) {
          <th>{{checkTranslation(headerText)}}</th>
        }
        <th class="close-td"></th>
      </tr>
    </thead>

    <tbody>
      @for (section of shownSections; track section; let i = $index) {
        <tr class="table-data grouped-repeater-table-data"
          >
          @for (dataItem of formControls; track dataItem) {
            <td>
              <div (click)="openSectionCheckboxes(section)"
                [ngStyle]="{width: dataItem.Width == null ? '80px' : dataItem.Width + 'px'}">
                @switch (dataItem.EditType) {
                  @case ('Text') {
                    <sem-text-box [isPasswordInput]="false" [isNumberInput]="false" class="group-repeater-content" [form]="form"
                      [ngModel]="getProp(dataItem.BindingField, section)" [isNumberInput]="checkIfNumber(dataItem.IsNumberInput)"
                    (ngModelChange)="setProp(dataItem.BindingField, $event, section)" name="{{dataItem.BindingField + section.Id}}"></sem-text-box>
                  }
                  @case ('DD') {
                    <sem-drop-down-select class="group-repeater-content" [form]="form" [titleField]="dataItem.TitleField"
                      [parent]="guid" [galregistryname]="dataItem.ModelName"
                      [ngModel]="getProp(dataItem.BindingField, section)"
                      [filterField]="dataItem.FilterField"
                      (ngModelChange)="setProp(dataItem.BindingField, $event, section)"
                      [subBindingPropertyName]="'dataItem.DisplayName'" [type]="dataItem.DropDownType" [preLoad]="true"
                      (itemSelected)="ddItemSelected($event)" name="{{dataItem.BindingField + section.Id}}"
                      [multiFieldRootPropertyBinding]="''" [additionalProjection]="dataItem.DropdownAdditionalProjection" [waitForFilteredValue]="false" [filteredValueBinding]="''">
                    </sem-drop-down-select>
                  }
                  @case ('Date') {
                    <sem-date-picker class="group-repeater-content" [form]="form"
                      [ngModel]="getProp(dataItem.BindingField, section)"
                      (ngModelChange)="setProp(dataItem.BindingField, $event, section)"
                      name="{{dataItem.BindingField + section.Id}}" date-format="DD/MM/YYYY" [templateType]="'calendar_month'">
                    </sem-date-picker>
                  }
                  @case ('CB') {
                    <sem-check-box class="group-repeater-content" [form]="form"
                      [ngModel]="getProp(dataItem.BindingField, section)"
                      (ngModelChange)="setProp(dataItem.BindingField, $event, section)"
                      name="{{dataItem.BindingField + section.Id}}">
                    </sem-check-box>
                  }
                }
              </div>
            </td>
          }
          <td class="tbody-close-td"><span class="close" style="display: block;" (click)="removeSection(section)"></span></td>
        </tr>
      }
    </tbody>

  </table>

  @if (maxCount == -1 || currentNumber < maxCount) {
    <div class="manipulate-section right-sub-section-holder dataIsLinked" (click)="addSection()"
      >
      <div class="icon-link-data repeater-icon"></div>
      <p class="repeater-text">
        {{checkTranslation('AddNew')}}
      </p>
    </div>
  }
</div>

@if (showCheckboxDiv) {
  <div class="repeater-checkboxes">
    <table>
      <tr>
        <td>{{controls.CheckBoxModelTitle}}</td>
        <td (click)="close()"><span class="close"></span></td>
      </tr>
      @for (item of repeaterItemCheckboxes; track item) {
        <tr>
          <td>{{item[controls["CheckBoxModelShownField"]]}}</td>
          <td>
            <div class="checkbox-repeater" (click)="checkboxClicked(item)"
              [ngClass]="{'checkbox-repeater-checked': item.Checked == true}">
              <input type="checkbox" name="item.Title" />
            </div>
          </td>
        </tr>
      }
    </table>
  </div>
}
